import { Navigate, Route } from "react-router";
import { all_routes } from "../router/allRoute";

import Login from "../pages/auth/login/login";
import Register from "../pages/auth/register/register";
import Dashboard from "../pages/Dashboard/dashboard";
import VerifyOtp from "../pages/auth/verify-otp/verify-otp";

import PatientFamilyMember from "../pages/patient/patient-family-member/patient-family-member";

import Appointment from "../pages/appointment/appointment";
import AppointmentList from "../pages/appointmentList/appointmentList";



const routes = all_routes;

export default function getRoutes() {
  return [
    {
      path: "/",
      component: Login,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.login,
      component: Login,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.register,
      component: Register,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.dashboard,
      component: Dashboard,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.verifyOtp,
      component: VerifyOtp,
      route: Route,
      role: ["SuperAdmin", "User"],
    },

    {
      path: routes.PatientFamilyMember,
      component: PatientFamilyMember,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
    {
      path: routes.Appointment,
      component: Appointment,
      route: Route,
      role: ["SuperAdmin", "User"],
    },
      {
      path: routes.appointmentList,
      component: AppointmentList,
      route: Route,
      role: ["SuperAdmin", "User"],
    },




    // Add more routes here as needed
  ];
}
